import {defineMessages} from 'react-intl';

export const messages = defineMessages({
  placeholder: {
    id: 'Search.Input.placeholder',
    defaultMessage: 'Event, artist or team',
    description: 'default message in search box',
  },
  searchInputTitle: {
    id: 'Search.Input.title',
    defaultMessage: 'Search input',
    description: 'title attribute for search input',
  },
});
